export default __webpack_public_path__ + "static/media/loginScreen2.acafb2e0.svg";